<template>
  <div>
    <button
      @click="downloadList"
      class="button text-white bg-theme-1 shadow-md mr-2"
    >
      {{ text }}
    </button>
    <a
      ref="download"
      target="_blank"
      rel="noopener noreferrer nofollow"
      class="hidden"
      >{{ text }}
    </a>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import axios from '@/services/axios'
export default {
  name: 'DownloadParticipations',
  props: {
    text: {
      type: String,
      default: 'Descargar Participaciones',
    },
    activity: {},
  },
  methods: {
    downloadList() {
      axios
        .get(`activity/participations-excel/${this.activity.id}`)
        .then((response) => {
          const { data } = response
          const { path } = data

          this.$refs.download.href = path
          this.$refs.download.click()
        })
    },
    ...mapActions(['get']),
  },
}
</script>



// WEBPACK FOOTER //
// DownloadParticipations.vue?2dda0028